import { useQuery } from 'react-apollo'
import { useFulfillment } from '../components/FulfillmentProvider/FulfillmentProvider'
import { useRestaurant } from '../components/RestaurantProvider/RestaurantProvider'
import { POPULAR_ITEMS } from '../components/PopularItems/PopularItems.graphql'

export const usePopularItems = () => {
  const { restaurantGuid, shortUrl } = useRestaurant()
  const { fulfillmentTime } = useFulfillment()
  return useQuery(POPULAR_ITEMS, {
    variables: {
      input: { restaurantGuid,
        menusInput: {
          shortUrl,
          dateTime: fulfillmentTime || undefined
        }
      }
    }
  })
}
